import { Button, Dialog, DialogPosition } from '@optimus-web/core';
import { useDialog, lt } from '@mews/framework';
import { AccountAddNoteForm } from '../../../accountNotes/components/AccountAddNoteForm';

interface FormDialogProps {
    ownerId: string;
}
export const AccountNoteDialog = ({ ownerId }: FormDialogProps) => {
    const [dialogProps, openDialog] = useDialog();
    const { onClose, active } = dialogProps;

    return (
        <>
            <Button onClick={openDialog} type="submit">
                {lt('AddNote')}
            </Button>
            <Dialog
                onClose={onClose}
                active={active}
                position={DialogPosition.Center}
                size="small"
                title={lt('NewNote')}
            >
                <AccountAddNoteForm ownerId={ownerId} onClose={onClose} />
            </Dialog>
        </>
    );
};
